import { render, staticRenderFns } from "./NewNoteForm.vue?vue&type=template&id=c771ccc8&scoped=true&"
import script from "./NewNoteForm.vue?vue&type=script&lang=js&"
export * from "./NewNoteForm.vue?vue&type=script&lang=js&"
import style0 from "./NewNoteForm.vue?vue&type=style&index=0&id=c771ccc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c771ccc8",
  null
  
)

export default component.exports